// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import { useToast } from '@react/shared/components/Toast';
import { NOTIFY_AGENT_RECEIVED_REQUEST } from '@sly/core/constants/notification';
import Helmet from 'next/head';
import { StrictMode, useRef } from 'react';
import { AgentsRegionPageContentProps } from 'sly/agentsRegionPage/AgentsRegionPageContent/AgentsRegionPageContent.types';

import AgentsRegionPageData from './AgentsRegionPageData';

export default function AgentsRegionPageContent({
  agentsList,
  title,
  locationName,
  isRegionPage,
}: AgentsRegionPageContentProps) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { pushSuccess: notifyInfo } = useToast();
  const titleRef = useRef<HTMLDivElement>(null);
  const postSubmit = () => {
    notifyInfo(NOTIFY_AGENT_RECEIVED_REQUEST);
    if (titleRef.current) {
      titleRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <StrictMode>
      <Helmet>
        <title>{`${locationName} Senior Living Advisors | Seniorly Partner Agents`}</title>
        <meta
          name='description'
          content={`Talk to local senior living advisors and partner agents in the ${locationName} region. Find a ${locationName} senior living advisor for personalized support!`}
        />
        {!isRegionPage && <meta name='robots' content='noindex' />}
      </Helmet>
      <Header />
      <AgentsRegionPageData
        title={title}
        locationName={locationName}
        agentsList={agentsList}
        postSubmit={postSubmit}
        titleRef={titleRef}
      />
      <Footer />
    </StrictMode>
  );
}
